export default {
    blue: "#2c2d84",
    link: "#2c2d84",

    grey1: "#212121",
    grey2: "#343434",
    grey3: "#999999",
    grey4: "#b6b6b6",
    grey5: "#F7F6F2",

    brown: "#C7BAA6",

    green: "#94AC43",

    focus: "#FFB81C",

    paleOrange: "#F5F1E0",
    
    maxWidth: "930px",
    
    darkText: "#1E2428",
    lightText: "#43484D",
    link: "#2c2d84",
    shadow: "#D8DDE0",
    background: "#F0F3F2",
    white: "#ffffff",
    focus: "#FFB81C",
    activeCard: "#fafafa",

    // service colours
    active: "#98D9CA",
    support: "#F7ADB6",
    learning: "#BBEAFA",
    cultural: "#FAC9A3",
    social: "#A9BAE1",

    health: "#98D9CA",
    family: "#F7ADB6",
    skills: "#BBEAFA",
    home: "#FAC9A3",
    time: "#A9BAE1",
    children: "#E36588",

    maxWidth: "1000px",

    // breakpoints
    smartphone: "250px",
    tablet: "750px",
    desktop: "1000px",
    largeDesktop: "1500px"
}